/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

const AuthCollapseWrapper = styled.div.attrs({
    'data-auto-collapse': 'howToGetAccess',
})`
    position: relative;
    border: 1px solid ${colors.pageAuthBorderColor};
    border-top: none;

    & a {
        ${fonts.textLink};
        &:hover {
            border-bottom: 1px solid;
        }
    }
`;

const AuthCollapsePanelContainerStyle = `
    border-bottom: 1px solid ${colors.pageAuthBorderColor};
    &:last-child {
        border-bottom: none;
    }
`;

const AuthCollapseTitleStyle = `
    padding: 20px 56px;
`;

const AuthCollapseBodyStyle = `
    padding: 0 56px 20px;
    & .auth-collapse__link {
        font-family: ${fonts.textLink}
    }
    & .auth-collapse__additional-phone {
        margin: 0;
    }
`;

export {
    AuthCollapseBodyStyle,
    AuthCollapsePanelContainerStyle,
    AuthCollapseTitleStyle,
    AuthCollapseWrapper,
};
